<template>
  <div id="assante-footer" class="notranslate">
    <footer>
      <div class="container">
        <div class="footer-links">
          <ul id="nav_help">
            <li>
              <a id="language-toggle" href="#" @click="toggleLanguage">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/></svg>
                <var id="lang-en" v-bind:class="{ active: language === 'english' }">English</var>
                <var>&nbsp;&nbsp;|&nbsp;&nbsp;</var>
                <var id="lang-fr" v-bind:class="{ active: language === 'french' }">Fran&ccedil;ais</var>
              </a>
            </li>
            <li><a target="_blank" href="https://support.assanteconnect.com" v-t>Support</a></li>
            <li><a href="/contact" v-t>Contact us</a></li>
          </ul>
          <ul id="nav_legal">
            <li>
              <a :href="privacyLink" v-t>Privacy</a>
            </li>
            <li>
              <a :href="tosLink" v-t>Terms of service</a>
            </li>
          </ul>
        </div>

        <div class="footer-disclaimer">
          <p class="disclaimer">
            <span v-t>
              Assante Connect is an online platform provided by CI Direct Investing (“CIDI”), a registered trade name for CI Investment Services Inc., providing managed investment portfolios as well as personalized financial advice and planning.
            </span>
            <br>
            <span v-t>
              CI Investment Services Inc. ("CIIS") is a registered investment dealer under the securities legislation in all provinces and territories in Canada, and member of the Canadian Investor Protection Fund and Canadian Investment Regulatory Organization.
            </span>
            <span v-t>
              CIIS is a wholly owned subsidiary of CI Financial Corp. ("CI Financial"), an independent company offering global wealth management and asset management advisory services.
            </span>
          </p>
        </div>

      </div>
    </footer>
  </div>
</template>
<script>
import Locale from 'utils/locale';

export default {
  created() {
    this.language = Locale.getLanguage();
  },
  data() {
    return {
      language: null,
    };
  },
  computed: {
    privacyLink() {
      return (this.language === 'french') ? 'https://www.cifinancial.com/ci-di/ca/fr/clientdisclosure.html#tab-item-6' : 'https://www.cifinancial.com/ci-di/ca/en/clientdisclosure.html#tab-item-6'
    },
    tosLink() {
      return (this.language === 'french') ? 'https://www.cifinancial.com/ci-di/ca/fr/clientdisclosure.html#tab-item-5' : 'https://www.cifinancial.com/ci-di/ca/en/clientdisclosure.html#tab-item-5'
    }
  },
  methods: {
    toggleLanguage() {
      if (Locale.getLanguage() === 'english') {
        this.language = 'french';
      } else {
        this.language = 'english';
      }
      Locale.setLanguage(this.language);
      this.$emit('language-changed', this.language);
    },
  },
};
</script>
<style lang="scss" scoped>
  #assante-footer {
    footer {
      background: #003e51;
      -webkit-box-shadow: inset 0 3px 4px -2px rgba(0, 0, 0, .4);
      box-shadow: inset 0 3px 4px -2px rgba(0, 0, 0, .4);
      color: #fff;
      font-size: .875em;
      height: 100%;
    }

    footer .container {
      margin: 0 auto;
      max-width: 1280px;
      padding: 1em 15px;
    }

    footer #language-toggle {
      display: flex;
      align-items: baseline;
      svg {
        width: 18px;
        height: 1rem;
        margin-right: 0.25rem;
        fill: white;
        align-self: center;
      }

      .active {
        font-weight: bold;
      }

      &:focus {
        text-decoration: none;
      }
    }

    footer .container ul {
      display: block;
      list-style: none;
      margin: 8px 0 0 20px;
      padding: 0;
    }

    footer .container ul li {
      display: inline-block;
      margin: 10px 20px 10px 0;
    }

    footer .container ul li a {
      color: #fff;
      display: block;
      text-decoration: none;
    }

    footer .container ul li a:focus,
    footer .container ul li a:hover {
      background: none;
      text-decoration: underline;
    }

    footer .container p.disclaimer {
      color: hsla(0, 0%, 100%, .6);
      margin: 20px;
      text-align: justify;
    }

    footer .container p.disclaimer a {
      color: hsla(0, 0%, 100%, .6);
      text-decoration: underline;
    }

    @media (min-width: 840px) {
      footer .footer-links {
        display: flex;
        justify-content: space-between;
      }

      footer .container ul {
        display: inline-block;
      }

      footer .container ul#nav_help {
        width: auto;
      }

      footer .container ul#nav_legal {
        text-align: right;
      }
    }

    @media (min-width: 950px) {
      footer .container {
        padding: 1em 20px;
      }

      footer .container ul {
        margin: 8px 0 0 30px;
      }

      footer .container ul li {
        margin: 10px 30px 10px 0;
      }

      footer .container p.disclaimer {
        margin: 20px 30px;
      }
    }

    @media (min-width: 1280px) {
      footer .container {
        padding: 1em 10px;
      }
    }

    @media (max-width: 1224px) {
      footer .footer-links {
        display: inline-block;
      }
    }
  }

</style>
